import type { PageHeaderPrimaryProps } from "@octopusdeploy/design-system-components";
import { PageHeaderPrimary } from "@octopusdeploy/design-system-components";
import React from "react";
import { useIsVerticalNavigationEnabled } from "../RootRoutes/useIsVerticalNavigationEnabled";
// This is a temporary wrapper for the primary header component to support use of the vertical navigation feature flag without blocking the page header from moving into the design system.
export function PortalPageHeaderPrimary(props: Omit<PageHeaderPrimaryProps, "isVerticalNavigationEnabled">) {
    const isVerticalNavigationEnabled = useIsVerticalNavigationEnabled();
    return <PageHeaderPrimary {...props} isVerticalNavigationEnabled={isVerticalNavigationEnabled}/>;
}
